






























import {Vue, Component, Prop} from 'vue-property-decorator';
import {ResizeDialogEvents} from '@/events';

@Component({
	name: 'ResizeDialog'
})
export default class ResizeDialog extends Vue {
	@Prop()
	private initialWidth: number;

	@Prop()
	private initialHeight: number;

	private width: number = null;
	private height: number = null;
	private lockAspectRatio: boolean = true;

	get aspectRatio(): number
	{
		return this.initialHeight / this.initialWidth;
	}

	public onWidthChanged()
	{
		if (this.lockAspectRatio && this.aspectRatio)
		{
			this.height = Math.round(this.width * this.aspectRatio);
		}
	}

	public onHeightChanged()
	{
		if (this.lockAspectRatio && this.aspectRatio)
		{
			this.width = Math.round(this.height / this.aspectRatio);
		}
	}

	public onConfirmClicked()
	{
		this.$emit(ResizeDialogEvents.resizeConfirmed, {width: this.width, height: this.height});
	}

	public onCancelClicked()
	{
		this.$emit(ResizeDialogEvents.resizeCanceled);
	}
}
